// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FMcH","type":"styles_type__2dZKM","choices":"styles_choices__1sW-u"};